module.exports = __webpack_public_path__ + "img/c00_buildingtechcombinedarms_Normal_ua.b68580f9.webp";